import type { WordCardKind } from "@-/dev.improve.haniverse.database.schemas.actor.schema";
import { selectEarliestStartedStudyCards } from "#select-earliest-started-study-cards";

type WordStudyCardCandidate = {
  startedStudyingAt: string | null;
  userWordSentenceCard?: { kind: WordCardKind; word: string } | null;
};

/**
 * Selects the one study card that establishes each learned word: its characters-in-context card,
 * the word's primary card (`useCreateUserWordCard`), as a glyph → meaning card is a character's.
 * The in-sentence typing and speaking drills do not make a word learned, and a word enrolled under
 * two readings still counts once.
 */
export function selectLearnedWordStudyCardsByWord<const TStudyCard extends WordStudyCardCandidate>(
  activeStudyCards: readonly TStudyCard[],
): ReadonlyMap<string, TStudyCard> {
  return selectEarliestStartedStudyCards(activeStudyCards, (studyCard) =>
    studyCard.userWordSentenceCard?.kind === "characters-in-context"
      ? studyCard.userWordSentenceCard.word
      : undefined,
  );
}
